import _extends from "@babel/runtime/helpers/extends";

/*
 * Licensed Materials - Property of IBM
 * 5724-Q36
 * (c) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import React from 'react';
import { pkg } from '../../../settings';
import { DataTable } from 'carbon-components-react';
import { NoDataEmptyState } from '../../EmptyStates/NoDataEmptyState';
var blockClass = "".concat(pkg.prefix, "--datagrid");
var TableBody = DataTable.TableBody,
    TableRow = DataTable.TableRow,
    TableCell = DataTable.TableCell;

var DatagridEmptyBody = function DatagridEmptyBody(datagridState) {
  var getTableBodyProps = datagridState.getTableBodyProps,
      headers = datagridState.headers,
      emptyStateTitle = datagridState.emptyStateTitle,
      emptyStateDescription = datagridState.emptyStateDescription,
      emptyStateSize = datagridState.emptyStateSize,
      illustrationTheme = datagridState.illustrationTheme;
  return /*#__PURE__*/React.createElement(TableBody, _extends({}, getTableBodyProps(), {
    className: "".concat(blockClass, "__empty-state-body")
  }), /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    colSpan: headers.length
  }, /*#__PURE__*/React.createElement(NoDataEmptyState, {
    illustrationTheme: illustrationTheme,
    size: emptyStateSize,
    title: emptyStateTitle,
    subtitle: emptyStateDescription
  }))));
};

export default DatagridEmptyBody;